import { FormControl, FormGroup } from '@angular/forms';

export type NewsletterControls = {
  email: FormControl<string>;
  regulations: FormControl<boolean>;
  recaptcha: FormControl<boolean>;
};

export class NewsletterFormData {
  public constructor(
    private readonly data: {
      email: string;
    },
  ) {}

  public get email(): string {
    return this.data.email;
  }
}

/* prettier-ignore */
export type NewsletterFormGroup = FormGroup<NewsletterControls>;
